import React from "react";
import { TransactionsRefundSummary } from "../../../../components/Transactions";

class RefundSummaryScreen extends React.Component {
  render() {
    return (
      <div>
        <TransactionsRefundSummary />
      </div>
    );
  }
}

export default RefundSummaryScreen;
